__turbopack_context__.v({
  "errorText": "helpCenterSearch-module-scss-module__oWSi3a__errorText",
  "errorWrapper": "helpCenterSearch-module-scss-module__oWSi3a__errorWrapper",
  "focusWrapper": "helpCenterSearch-module-scss-module__oWSi3a__focusWrapper",
  "icon": "helpCenterSearch-module-scss-module__oWSi3a__icon",
  "input": "helpCenterSearch-module-scss-module__oWSi3a__input",
  "wrapper": "helpCenterSearch-module-scss-module__oWSi3a__wrapper",
});
